import React from 'react'
import { useNavigate  } from "react-router-dom";

export const NotFoundPage = () => {
  const navigate = useNavigate();

  setTimeout(()=>{
    navigate(-1)
  },2000)
  // useEffect(()=>{
    
  //   history.goBack()
  // },[])
  return (
    <div>
      404 Page Not founded
    </div>
  )
}
